import { render, staticRenderFns } from "./LocationServices.vue?vue&type=template&id=072bc67e&"
import script from "./LocationServices.vue?vue&type=script&lang=js&"
export * from "./LocationServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports